export default __webpack_public_path__ + "static/media/4.333c6945.png";